import { post, postMethod, getMethod, get } from '@/axios/index'
const api = '/mini'
export const getLoginUserInfo = (p) => post(api + '/login/getLoginUserInfo', p)
export const getArticleCategory = (p) => postMethod(api + '/articleCategory/list', p)
export const getUnionid = (p) => get(api + '/login/getUnionid', p)
export const loginUser = (p) => post(api + '/login/webLoginUser', p)
export const loginUserM = (p) => post(api + '/login/loginUser', p)
export const myArticleList = (p) => post(api + '/article/myArticleList', p)
export const mySubscribedArticleList  = (p) => post(api + '/article/mySubscribedArticleList', p)
export const articleRecord = (p) => postMethod(api + '/myArticleRecord', p)
export const getAIConfig = (p) => postMethod(api + '/getAiConfig', p)
export const getResult = (p) => get(api + '/getResult', p)
const api1 = '/articleRecord'
export const myArticleFavorList = (p) => post(api1 + '/myFavor', p)

export const unreadCount = (p) => get(api1 + '/unreadCount', p)
export const readComment = (p) => post(api1 + '/readComment', p)

export const readAllComment = (p) => get(api1 + '/readAllComment', p)
const api2 = '/miniReport'
export const myReportList = (p) => getMethod(api2 + '/reportList', p)
export const createArticleReport = (p) => post(api + '/createArticleReport', p)
export const getRecodes = (p) => post('/cache/redis/getRecodes', p)

export const makeRecords = (p) => post('/cache/redis/makeRecords', p)